import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/calendar_events`;

const model = abstractModel(resource);

model.list = async (params = {}) => model.get(params);

model.create = async (payload) => model.save({ calendar_event: payload });

model.update = async (id, payload) => model.put({ id, calendar_event: payload });

model.destroy = async (id) => model.remove({ id });

export default model;
